module.exports = __webpack_public_path__ + "static/media/Lindö soffa med öppet avslut tyg Elsa beige 02 ben ek miljö 2025 4.edc08f95.jpg";